<template>
  <div class="account-details-view">
    <!-- Page Header -->
    <div class="page-header">
      <div>
        <h1 class="page-title">{{ business.name || 'Détails du compte' }}</h1>
        <v-breadcrumbs :items="items" class="page-breadcrumbs">
          <template v-slot:divider>
            <v-icon small>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>
      </div>
    </div>

    <!-- Preloader -->
    <PreloaderComponent :enable="enable"></PreloaderComponent>

    <!-- Content -->
    <div class="content-container" v-if="enable">
      <v-card class="details-card">
        <v-tabs
          v-model="activeTab"
          class="modern-tabs"
          centered
          grow
          height="56"
          slider-color="secondary"
        >
          <v-tab v-for="tab in tabs" :key="tab.id">
            <v-icon left small>{{ tab.icon }}</v-icon>
            {{ tab.name }}
          </v-tab>

          <v-tab-item key="1">
            <ProfileView :profile="profile" :business="business"></ProfileView>
          </v-tab-item>
          <v-tab-item key="2">
            <StoresView :stores="stores" :business="business"></StoresView>
          </v-tab-item>
          <v-tab-item key="3">
            <DevicesView :devices="devices" :stores="stores" :business="business" @refresh="load"></DevicesView>
          </v-tab-item>
          <v-tab-item key="4">
            <RenewalsView :devices="devices" :stores="stores" :business="business" :renewals="renewals"></RenewalsView>
          </v-tab-item>
          <v-tab-item key="5">
            <UsersView :business="business" :users="users"></UsersView>
          </v-tab-item>
          <v-tab-item key="6">
            <KlPayView :business="business" @refresh="load"></KlPayView>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </div>
  </div>
</template>

<script>
import PreloaderComponent from '../../components/PreloaderComponent.vue'
import ProfileView from './ProfileView.vue'
import StoresView from './StoresView.vue'
import DevicesView from './DevicesView.vue'
import RenewalsView from './RenewalsView.vue'
import UsersView from './UsersView.vue'
import KlPayView from './KlPayView.vue'

export default {
  name: 'AccountDetailsView',
  methods: {
    init: function () {
      this.tabs = [
        {id: 1, name: "Profil", icon: "mdi-account-circle"},
        {id: 2, name: 'Magasins', icon: "mdi-store"},
        {id: 3, name: 'Appareils', icon: "mdi-cellphone"},
        {id: 4, name: 'Renouvellements', icon: "mdi-autorenew"},
        {id: 5, name: 'Utilisateurs', icon: "mdi-account-group"},
        {id: 6, name: 'KL Pay', icon: "mdi-contactless-payment"},
      ]

      this.users = []
    },
    updateDeviceInfo: function (data) {
      for (var i = this.devices.length - 1; i >= 0; i--) {
        if (this.devices[i].id == data.id) {
          this.devices[i] = data
        }
      }
    },
    load: function () {
      var self = this;
      this.$axios.get("/businesses/" + this.$route.params.id + "?include=stores,devices,renewals")
          .then(function (response) {
            console.log("HH")
            self.business = response.data
            self.profile = [
              {label: "NOM ENTREPRISE", name: response.data.name, key: "name"},
              {label: "TELEPHONE", name: response.data.phone, key: "phone"},
              {label: "E-MAIL", name: response.data.email, key: "email"},
              {label: "ADRESSE", name: response.data.address, key: "address"},
              {label: "NOM CONTACT", name: response.data.contact_full_name, key: "contact_full_name"},
              {label: "TELEPHONE CONTACT", name: response.data.contact_phone, key: "contact_phone"},
              {label: "E-MAIL CONTACT", name: response.data.contact_email, key: "contact_email"},
              {label: "IDENTIFICATION", name: response.data.contact_id, key: "contact_id"},
              {label: "TYPE IDENTIFICATION", name: response.data.contact_id_type, key: "contact_id_type"},
              {label: "SOUS-DOMAINE", name: response.data.prefix, key: "prefix"},
              {label: "UID", name: response.data.uid || '--', key: "uid"}
            ]
            self.stores = response.data.stores
            self.renewals = response.data.renewals
            self.devices = response.data.devices
            self.items = [
              {
                text: 'COMPTES',
                disabled: false,
                href: '/accounts',
              },
              {
                text: 'PROFIL',
                disabled: false,
                href: '#',
              },
              {
                text: response.data.name,
                disabled: false,
                href: '#',
              }
            ]
            self.enable = true
          });


    },

    loadUsers: function(){
      var self = this;
      this.$axios.get("/dashboard/businesses/users/" + this.$route.params.id)
          .then(function (response) {
            // console.log("Response received:", response);
            self.users = response.data.data.users;
            self.enable = true;
            // console.log("Users:", self.users);
          })
          .catch(function (error) {
            console.error("API error:", error);
          });
    }
  },
  mounted() {
    this.init()
    this.load()
    this.loadUsers()
  },
  data: () => ({
    business: [],
    account: {id: 0},
    id: 0,
    rates: [],
    enable: false,
    profile: [],
    renewals: [],
    stores: [],
    devices: [],
    users: [],
    items: [
      {
        text: 'COMPTES',
        disabled: false,
        href: '/accounts',
      },
      {
        text: 'PROFIL',
        disabled: false,
        href: '#',
      }
    ],
    tab: null,
    activeTab: 0,
    tabs: [],
  }),
  components: {PreloaderComponent, ProfileView, StoresView, DevicesView, RenewalsView, UsersView, KlPayView},
}
</script>

<style lang="scss" scoped>
.account-details-view {
  min-height: 100%;
}

.page-header {
  padding: 24px;
  
  .page-title {
    font-size: 24px;
    font-weight: 600;
    margin: 0 0 8px;
  }
}

.page-breadcrumbs {
  padding: 0 !important;
  
  ::v-deep .v-breadcrumbs__item {
    font-size: 13px;
  }
}

.content-container {
  padding: 0 24px 24px;
}

.details-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.modern-tabs {
  ::v-deep .v-slide-group__wrapper {
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }
  
  ::v-deep .v-tab {
    text-transform: none !important;
    font-weight: 500;
    letter-spacing: 0;
    
    &--active {
      color: #F68D3A !important;
    }
  }
  
  ::v-deep .v-tabs-slider {
    background-color: #F68D3A;
  }
}

.theme--dark .modern-tabs {
  ::v-deep .v-slide-group__wrapper {
    border-bottom-color: rgba(255, 255, 255, 0.08);
  }
}
</style>